module.exports = __webpack_public_path__ + "img/gs2.9a74c5f0.svg";